import React, { Component } from 'react';
import { DetailsList, DetailsListLayoutMode, TextField, mergeStyleSets, CommandBar, Panel, PanelType, Selection, SelectionMode, IColumn, FontIcon, TooltipHost, IconButton } from 'office-ui-fabric-react';
import { MyContext } from '../../context';
import ProfileSettings from './ProfileSettings';


const classNames = mergeStyleSets({
    container: {
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
    },
    header: {
        padding: '0',
    },
    detailsList: {
        flexGrow: 1,
        overflowX: 'auto',
    },
    commandBar: {
        width: '100%',
    },
});
export interface IDocument {
    name: String;
    text: String;
    rules: String;

}

export interface IDetailsListDocumentsExampleState {
    columns: IColumn[];
    items: IDocument[];
    selectionDetails: string;
    isModalSelection: boolean;
    isCompactMode: boolean;
}
class Profiles extends React.Component<{}, IDetailsListDocumentsExampleState> {
    _selection: Selection;
    _allItems: IDocument[];

    static contextType = MyContext

    tooltipProps: ITooltipProps = {
        onRenderContent: () => (
            <div>
                <div>
                    {this.context.getTranslation("recordingRule", "createProfileTooltipTextHeader")}
                </div>
                <div>
                    {this.context.getTranslation("recordingRule", "createProfileTooltipTextSubtitle")}
                </div>
                <ul>
                    <li>{this.context.getTranslation("recordingRule", "createProfileTooltipTextOpt1")}</li>
                    <li>{this.context.getTranslation("recordingRule", "createProfileTooltipTextOpt2")}</li>
                </ul>
                <div>
                    {this.context.getTranslation("recordingRule", "createProfileTooltipText")}
                </div>
            </div>
        ),
    };
    constructor(props) {
        super(props);
        this._allItems = _generateDocuments(this.props.profileData);
        this._selection = new Selection({
            onSelectionChanged: () => {
                this.setState({
                    selectionDetails: this._getSelectionDetails()
                });
            }
        });
        let columns: IColumn[] = [

            {
                key: 'column1',
                name: <MyContext.Consumer>{context => context.getTranslation("configuration", "name")}</MyContext.Consumer>,
                fieldName: 'name',
                minWidth: 100,
                maxWidth: 200,
                isResizable: true,
                onColumnClick: this._onColumnClick,
            },
            { key: 'column2', name: <MyContext.Consumer>{context => context.getTranslation("configuration", "description")}</MyContext.Consumer>, fieldName: 'text', minWidth: 100, maxWidth: 200, isResizable: true },
            {
                key: 'column3', name: <MyContext.Consumer>{context => context.getTranslation("configuration", "rules")}</MyContext.Consumer>, fieldName: 'rules', minWidth: 100, maxWidth: 200, isResizable: true, onRender: (item) => {
                    return this.mapRuleIdsToNames(item.rules, this.props.profileRulesData, this.props.ruleData)
                }
            },
            {
                key: 'settings',
                name: '',
                fieldName: 'settings',
                minWidth: 40,
                maxWidth: 40,
                isResizable: false,
                onRender: (item) => (
                    <IconButton
                        iconProps={{ iconName: 'Settings', styles: { root: { fontSize: 12 } } }}
                        title="Edit"
                        ariaLabel="Edit"
                        onClick={() => this.openPanel('Edit Profile', false)}
                    />
                ),
            }
        ]

        this.state = {

            searchText: '',
            isPanelOpen: false,
            panelTitle: '',
            isNew: false,
            columns: columns,
            selectionDetails: this._getSelectionDetails(),
            isModalSelection: true,
            isCompactMode: true,
            count: 0,
            showModal: false,
            showModalMapping: false,
            profileItems: this._allItems,
            sortedColumnKey: 'name',
            isSortedDescending: false,
        };




    }

    componentDidUpdate(prevProps) {
        if (prevProps.profileData !== this.props.profileData) {
            const updatedItems = _generateDocuments(this.props.profileData);
            this._selection.setItems(updatedItems, true); // true = clear selection to update
            this.setState({ profileItems: updatedItems });
        }
    }
    _getSelectionDetails(): string {


        const selectedItems = this._selection.getSelection();

        if (selectedItems.length > 0) {

            return selectedItems[0];
        }
        return '';
    }

    onSearchChange = (event, newValue) => {
        this.setState({ searchText: newValue });
    };

    onSelectionChanged = () => {
        this.forceUpdate();
    };

    openPanel = (title, isNew) => {

        this.setState({ isPanelOpen: true, panelTitle: title, isNew: isNew });


    };

    closePanel = () => {
        this.setState({ isPanelOpen: false, panelTitle: '' });
    };

    _onColumnClick = (ev, column) => {
        const { profileItems, isSortedDescending, sortedColumnKey } = this.state;
        const newIsSortedDescending = sortedColumnKey === column.fieldName ? !isSortedDescending : false;
        const sortedItems = _copyAndSort(profileItems, column.fieldName, newIsSortedDescending);

        this.setState({
            profileItems: sortedItems,
            sortedColumnKey: column.fieldName,
            isSortedDescending: newIsSortedDescending,
        });
    };


    mapRuleIdsToNames(ruleIds, profileRuleData, ruleData) {
        const filteredRuleData = (ruleData || []).filter(rule => rule.group === "recording");
        const profileRules = [...profileRuleData, ...filteredRuleData];

        return ruleIds.map(id => {
            const rule = profileRules.find(rule => rule.id === id);
            return rule ? rule.name : id;
        }).join(', ');
    }

    render() {
        const { isCompactMode, columns, searchText, isPanelOpen, panelTitle, sortedColumnKey, isSortedDescending } = this.state;
        const sortedColumns = columns.map(col => ({
            ...col,
            isSorted: col.fieldName === sortedColumnKey,
            isSortedDescending: col.fieldName === sortedColumnKey ? isSortedDescending : false,
        }));
        const filteredItems = this.state.profileItems
            .filter(item =>
                item.name.toLowerCase().includes(searchText.toLowerCase()) ||
                item.text.toLowerCase().includes(searchText.toLowerCase())
            )


        const commandBarItems = [
            {
                key: 'createProfile',
                text: <MyContext.Consumer>{context => context.getTranslation("configuration", "createProfile")}</MyContext.Consumer>,
                iconProps: { iconName: 'Add' },
                onClick: () => this.openPanel('Create Profile', true),
                disabled: !this.props.accessProfiles
            },
            {
                key: 'edit',
                text: <MyContext.Consumer>{context => context.getTranslation("configuration", "edit")}</MyContext.Consumer>,
                iconProps: { iconName: 'Edit' },
                onClick: () => this.openPanel('Edit Profile', false),
                disabled: this._selection.getSelectedCount() !== 1,
            },
        ];

        const farItems = [
            {
                key: 'search',
                onRender: () => (
                    <TextField
                        placeholder="Search"
                        onChange={this.onSearchChange}
                        styles={{ root: { marginRight: 10, alignSelf: 'center' } }}
                    />
                ),
            },
        ];

        return (
            <MyContext.Consumer>
                {context => (
                    <div className={classNames.container}>
                        <div className={classNames.header}>
                            <CommandBar items={commandBarItems} farItems={farItems} className={classNames.commandBar} />
                        </div>
                        <DetailsList
                            items={filteredItems}
                            columns={sortedColumns}
                            setKey="set"
                            layoutMode={DetailsListLayoutMode.justified}
                            selection={this._selection}
                            selectionMode={SelectionMode.single}
                            selectionPreservedOnEmptyClick={true}
                            ariaLabelForSelectionColumn="Toggle selection"
                            checkButtonAriaLabel="select row"
                            styles={{ root: classNames.detailsList }}
                            isCompactMode={isCompactMode}
                        />
                        <Panel
                            isOpen={isPanelOpen}
                            onDismiss={this.closePanel}
                            type={PanelType.medium}
                            headerText={
                                <TooltipHost tooltipProps={this.tooltipProps}>
                                    {panelTitle}
                                    <FontIcon aria-label="Compass" iconName="Info" style={{ marginLeft: '10px', cursor: 'pointer' }} />

                                </TooltipHost>

                            }
                            closeButtonAriaLabel="Close"
                        >
                            <ProfileSettings profilesList={filteredItems} title={panelTitle} ruleData={this.props.ruleData} profileRulesData={this.props.profileRulesData} profileData={this.state.isNew ? null : this.state.selectionDetails} apol={this.props.apol} authorization={this.props.authorization} userRules={this.props.userRules} accessProfiles={this.props.accessProfiles} closePanel={this.closePanel} dataUsers={this.props.dataUsers} dataGroups={this.props.dataGroups} tenantData={this.props.tenantData} />
                        </Panel>
                    </div>
                )}
            </MyContext.Consumer>
        );
    }






}
function _copyAndSort<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
    const key = columnKey;
    return items.slice(0).sort((a: T, b: T) => ((isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1));
}

function _generateDocuments(DataArr) {
    const items = [];
    if (DataArr !== undefined && DataArr != null || DataArr !== "null") {
        for (let i = 0; i < DataArr.length; i++) {

            items.push(DataArr[i]);
        }
    }
    return items;
}

export default Profiles;